import React from "react";
import { connect } from "react-redux";
import IconProSaveForLater from "./icon-pro-save-for-later";
import IconBasicSaveForLater from "./icon-basic-save-for-later";

const IconSaveForLater = props => {
    if (props.isPro) {
        return <IconProSaveForLater {...props} />;
    } else {
        return <IconBasicSaveForLater {...props} />;
    }
};

const mapStateToProps = (state, ownProps) => {
    let { user } = state;
    let isPro =
        user && user.permissions && user.permissions.market == "premium";

    return {
        isPro
    };
};

export default connect(mapStateToProps, {})(IconSaveForLater);
